module.exports = __webpack_public_path__ + "static/media/face-sad-fill.6d08f6cd.svg";